import { useCallback, useMemo } from 'react'
import Fuse from 'fuse.js'

import type { GetTriggersTypesResponse } from '~/generated/client'

export const useTriggerOrActionFuseSearch = ({
  dataToSearch,
}: {
  dataToSearch: GetTriggersTypesResponse
}) => {
  const fuseInstance = useMemo(() => {
    const data =
      dataToSearch.items.map((item) => ({
        ...item,
        formatted_name: item.name,
      })) || []

    const fuse = new Fuse(data, {
      keys: [
        {
          name: 'formatted_name',
          weight: 6,
        },
        {
          name: 'description',
          weight: 1,
        },
      ],
      threshold: 0.5,
      includeScore: true,
      distance: 70,
      minMatchCharLength: 1,
    })

    return fuse
  }, [dataToSearch])

  const searchData = useCallback(
    (search: string) => {
      return search
        ? fuseInstance
            .search(search)
            .sort((a, b) => (a.score ?? 0) - (b.score ?? 0))
            .map((result) => result.item)
        : dataToSearch.items
    },
    [fuseInstance, dataToSearch],
  )

  return {
    searchData,
    fuseInstance,
  }
}
